import React, { useState, useEffect } from "react";
import axios from "axios";

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({ vendor_name: ""});
  
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleChange = (e) => {
    setFormData({ vendor_name: e.target.value });
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // Fetch vendors
  const fetchVendors = async () => {
    try {
      const response = await axios.get(
        "https://api-ims.indevconsultancy.in/vendor.php"
      );
      setVendors(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching vendors:", err);
      setLoading(false);
    }
  };

  // Add or Update Vendor
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.vendor_name.trim()) {
      alert("Please enter vendor name");
      return;
    }

    try {
      if (editMode) {
        // 🔥 CORRECT PUT URL
        await axios.put(
          `https://api-ims.indevconsultancy.in/vendor.php?id=${selectedId}`,
          formData
        );
        alert("Vendor updated successfully!");
      } else {
        // POST Add Vendor
        await axios.post(
          "https://api-ims.indevconsultancy.in/vendor.php",
          formData
        );
        alert("Vendor added successfully!");
      }

      fetchVendors();
    } catch (err) {
      console.error("Error saving vendor:", err);
      alert("Failed to save vendor");
    }

    setFormData({ vendor_name: "" });
    setEditMode(false);
    setSelectedId(null);

    const modal = document.getElementById("vendorModal");
    const instance = window.bootstrap.Modal.getInstance(modal);
    instance.hide();
  };

  // Edit Vendor
  const handleEdit = (item) => {
    setFormData({ vendor_name: item.vendor_name.trim() });
    setSelectedId(item.vendor_id);
    setEditMode(true);

    new window.bootstrap.Modal(
      document.getElementById("vendorModal")
    ).show();
  };

  // Delete Vendor
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this vendor?")) {
      try {
        // 🔥 CORRECT DELETE URL
        await axios.delete(
          `https://api-ims.indevconsultancy.in/vendor.php?id=${id}`
        );

        alert("Vendor deleted successfully!");
        fetchVendors();
      } catch (err) {
        console.error("Error deleting vendor:", err);
        alert("Failed to delete vendor");
      }
    }
  };

  // Filter by search
  const filteredVendors = vendors.filter((item) =>
    item.vendor_name.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentVendors = filteredVendors.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredVendors.length / itemsPerPage);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">

                <div className="card-header border-info d-flex justify-content-between">
                  <h5 className="fw-bold mb-0">Vendor List</h5>

                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#vendorModal"
                    onClick={() => {
                      setFormData({ vendor_name: "" });
                      setEditMode(false);
                    }}
                  >
                    Add Vendor
                  </button>
                </div>

                <div className="card-body">

                  {/* Search */}
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search vendor..."
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>

                  <table className="table table-bordered table-striped text-center">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>S.No.</th>
                        <th>Vendor Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3">Loading...</td>
                        </tr>
                      ) : currentVendors.length === 0 ? (
                        <tr>
                          <td colSpan="3">No vendors found.</td>
                        </tr>
                      ) : (
                        currentVendors.map((item, index) => (
                          <tr key={item.vendor_id}>
                            <td>{indexOfFirst + index + 1}</td>
                            <td>{item.vendor_name}</td>
                            <td>
                              <button
                                className="btn btn-success btn-sm me-2"
                                onClick={() => handleEdit(item)}
                              >
                                Edit
                              </button>

                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(item.vendor_id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <nav>
                    <ul className="pagination justify-content-center">

                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {Array.from({ length: totalPages }, (_, i) => (
                        <li
                          key={i}
                          className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      ))}

                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>

                    </ul>
                  </nav>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div className="modal fade" id="vendorModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {editMode ? "Edit Vendor" : "Add Vendor"}
                </h5>
                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <label className="form-label">Vendor Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.vendor_name}
                  onChange={handleChange}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>

                <button className="btn btn-primary" type="submit">
                  {editMode ? "Update Vendor" : "Add Vendor"}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorList;
